import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../actions/api";

const slice = createSlice({
  name: "healthPlan",
  initialState: {
    HealthPlansList: [],
    total: 0,
    currentPage: 1,
    toPage: null,
    lastPage: null,
    loading: false,
    error: null,
  },
  reducers: {
    fetchedHealthPlansSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.HealthPlansList = action.payload.data || [];
      state.total = action.payload.data.length || 0;
      state.currentPage = 1; // Default to 1 if no meta data
      state.toPage = action.payload.data.length || 10;
      state.lastPage = 1; // Assume single page if no pagination
    },
    fetchedHealthPlansStart: (state) => {
      state.loading = true;
    },
    fetchedHealthPlansFailed: (state, action) => {
      state.loading = false;
      state.error = action.payload || {
        message: "Failed to fetch health plans",
      };
    },
  },
});

const {
  fetchedHealthPlansSuccess,
  fetchedHealthPlansStart,
  fetchedHealthPlansFailed,
} = slice.actions;

export default slice.reducer;

const url = "/v1/admin/healthplans";

export const fetchHealthPlans = (pageItems, page) =>
  apiCallBegan({
    url: `${url}?page_items=${pageItems}&page=${page}`,
    method: "GET",
    onSuccess: fetchedHealthPlansSuccess.type,
    onStart: fetchedHealthPlansStart.type,
    onError: fetchedHealthPlansFailed.type,
  });

export const getHealthPlans = (state) => state.entities.enrolleeHealthPlans;
